import React from 'react';
import { Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';

interface PermissionDeniedProps {
  title?: string;
  message?: string;
  icon?: React.ReactNode;
}

/**
 * Inline "no permission" state for a section/module that lives inside an
 * already-navigated layout (sidebar, tabs) — unlike `Unauthorized`, it does
 * NOT redirect or leave the shell, it just replaces the module's content.
 *
 * TEMPORARY placeholder copy/visuals: design has not defined the final empty
 * state for this case yet (not in the current prototype) — swap this out
 * once that spec lands.
 */
export function PermissionDenied({
  title = 'No access to this module',
  message = "You don't have permission to view this section. Contact an administrator to request access.",
  icon = <LockOutlined style={{ fontSize: 40 }} />,
}: PermissionDeniedProps) {
  return (
    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result icon={icon} title={title} subTitle={message} />
    </div>
  );
}
